import { Component } from 'react';
import logo from '../../logo.png';
import { Menu, Icon, Accordion, Divider, Image } from 'semantic-ui-react';
import { Link, withRouter, } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { Button, Select, Modal, Input } from 'semantic-ui-react';
import { CompanyInitializer } from '../../CompanyInitializer';
import { Company } from '../../models/Company';
import { observer } from 'mobx-react';
import { withAuth0 } from '@auth0/auth0-react';
import { getSnapshot } from 'mobx-state-tree';

class NavigationMenu extends Component {
    constructor() {
        super();
        this.state = { playbookActive: false, customPlaybookActive: false, buildingMessageActive: false, onboardingTrainingActive: false, salesActivityActive: false, closingActive: false, skillsLeadershipActive: false, dashboardActive: false };
    }
    businessLineChange(e) {
        this.setState({ newCompanyName: e.target.value });
    }

    async onAddBusinessLineClick(data) {
        try {
            this.setState({ isLoading: true });

            const { newCompanyName } = this.state;
            const { companyStore, usersStore, assessmentsStore, adminStore } = this.props;

            const company = Company.create({
                name: newCompanyName,
                phone: '',
                streetAddress: '',
                zipCode: '',
                city: '',
                state: '',
            });

            await company.createFromSnapshot({
                name: newCompanyName,
                phone: '',
                streetAddress: '',
                zipCode: '',
                city: '',
                state: '',
            });

            await usersStore.currentUser
                .updateFromSnapshot({ ...getSnapshot(usersStore.currentUser), companyIds: [...usersStore.currentUser.companyIds, company.id] });

            await adminStore.loadEnterprise(usersStore.currentUser.userId);
            await CompanyInitializer(
                companyStore,
                assessmentsStore,
                usersStore,
                company.id
            );

            companyStore.setCompany(company);

            this.setState({ selectedCompanyId: company.id });
        } catch (e) {
            throw e;
        } finally {
            this.setState({ isLoading: false });
        }
    }

    logout = () => {
        const { history } = this.props;

        history.push('/');
        this.props.auth0.logout({
            returnTo: window.location.origin,
        });
    };

    onHeaderClick(header) {
        const { history } = this.props;
        if (header === 'Company Overview') {
            history.push('/v1/background');
        } else if (header === 'Feedback') {
            history.push('/v1/schedule-assessments');
        } else if (header === 'Performance Reports') {
            history.push('/v1/assessments-report');
        } else if (header === 'Offerings') {
            history.push('/v1/offerings');
        } else if (header === 'Question And Answer') {
            history.push('/v1/questions-answers');
        } else if (header === 'Dashboard') {
            history.push('/v1/dashboard');
        } else if (header === 'Recording') {
            history.push('/v1/record-presentation');
        } else if (header === 'General Asks') {
            history.push('/v1/general-asks');
        }
    }

    onModuleHeaderClick(module) {
        const { history } = this.props;

        history.push(module.articles[0].path);
    }

    companyOverviewActive() {
        const { history } = this.props;

        const path = history.location.pathname;

        return path === '/v1/background'
            || path === '/v1/differentiators'
            || path === '/v1/prospect-profile'
            || path === '/v1/top-competitors'
            || path === '/v1/addressable-problems';
    }

    offeringsActive() {
        const { history } = this.props;

        const path = history.location.pathname;

        return path.indexOf('offerings') > -1;
    }

    moduleActive(module) {
        const { history } = this.props;

        const path = history.location.pathname;

        const paths = module.articles.map(article => article.path);

        for (let i = 0; i < paths.length; i++) {
            if (paths[i] === path) {
                return true;
            }
        }
        return false;
    }

    dashboardSectionActive() {
        const { history } = this.props;
        const path = history.location.pathname;
        return path === '/v1/dashboard' || path === '/v1/team-dashboard';
    }

    assessmentsActive() {
        const { history } = this.props;
        const path = history.location.pathname;

        return path === '/v1/company-assessments'
            || path === '/v1/offering-assessments'
            || path === '/v1/schedule-assessments';
    }

    performanceReviewsActive() {
        const { history } = this.props;
        const path = history.location.pathname;

        return path === '/v1/assessments-report'
            || path === '/v1/value-report';
    }

    onCompanyChange(data) {
        this.props.onCompanyChange(data);
    }

    sortByName(a, b) {
        const nameA = a.company.name.toUpperCase(); // ignore upper and lowercase
        const nameB = b.company.name.toUpperCase(); // ignore upper and lowercase
        if (nameA < nameB) {
            return -1;
        }
        if (nameA > nameB) {
            return 1;
        }

        // names must be equal
        return 0;
    };

    renderAdminSelector(selectedCompanyId, adminStore, isCompanyAdmin) {
        const { isLoading } = this.state;

        return <div>
            <Select
                loading={isLoading}
                placeholder='Companies'
                onChange={(_, d) => this.onCompanyChange(d)}
                value={this.props.selectedCompanyId || adminStore.companies[0]?.company.id}
                options={adminStore.companies.sort(this.sortByName).map((c) => ({
                    text: c.company.name,
                    key: c.company.id,
                    value: c.company.id,
                }))} />
            {isCompanyAdmin &&
                <Modal
                    trigger={<Button icon='plus' title='Add Company' onClick={this.handleAddCompany} circular style={{ marginLeft: 5 }} primary />}
                    header='Add Business Line'
                    content={<div style={{ margin: 15 }}>What is the name of your new business line? <br /><br /><Input fluid onChange={(e) => this.businessLineChange(e)}></Input></div>}
                    actions={['Cancel', { key: 'save', content: 'Save', positive: true, onClick: async () => await this.onAddBusinessLineClick() }]}
                    size="small"
                />}
        </div>;
    }

    render() {
        const { selectedCompanyId } = this.state;

        const { location, currentUser, companyStore, adminStore, modulesStore, path } = this.props;
        const { isAdmin, isSalesMember, isCompanyAdmin, isReadOnlyExecutive, isReadOnlySalesManager, hasMoreThanOneCompany } = currentUser;
        const linkStyle = {
            marginLeft: '10px',
            textAlign: 'left'
        };
        const iconStyle = { float: 'left', marginRight: 10 };
        const dividerStyle = { borderTop: '1px solid rgba(7,132,167,.4)', width: 35, marginLeft: 10 };
        const menuItemStyle = { zIndex: 0 };

        const showAssessmentActions = !isSalesMember && !isReadOnlyExecutive && !isReadOnlySalesManager;
        const showAssessmentReports = !isSalesMember;
        const showUserManagement = !isSalesMember && !isReadOnlyExecutive && !isReadOnlySalesManager;
        const showRecordPresentation = !isReadOnlyExecutive && !isReadOnlySalesManager;
        const showModules = modulesStore.modules.length > 0;

        return (
            <Accordion as={Menu}
                style={{ borderTop: 'none', borderBottom: 'none', boxShadow: 'none', borderRightWidth: path === '/v1/record-presentation' ? '0' : '2px' }}
                vertical
                fluid
                secondary
                pointing>
                <Menu.Header style={{ textAlign: 'center' }}
                >
                    <Image src={logo} style={{ width: 100 }} alt="logo" as={Link}
                        to='/v1/' />
                    {this.renderAdminSelector(selectedCompanyId, adminStore, isCompanyAdmin || isAdmin)}
                </Menu.Header>
                <Divider style={dividerStyle} />
                <Menu.Item style={menuItemStyle}>
                    <Menu.Item as={Accordion.Title} onClick={() => this.onHeaderClick('Company Overview')}>
                        <Icon name="building" style={iconStyle} />
                        Company Overview
                    </Menu.Item>
                    <Accordion.Content active={this.companyOverviewActive()} >
                        <Menu.Menu>
                            <Menu.Item
                                style={linkStyle}
                                as={Link}
                                active={location.pathname === '/v1/background'}
                                to='/v1/background'>
                                Background
                            </Menu.Item>
                            <Menu.Item
                                style={linkStyle}
                                as={Link}
                                active={location.pathname === '/v1/differentiators'}
                                to='/v1/differentiators'>
                                Differentiators
                            </Menu.Item>
                            <Menu.Item
                                style={linkStyle}
                                as={Link}
                                active={location.pathname === '/v1/addressable-problems'}
                                to='/v1/addressable-problems'>
                                Addressable Problems
                            </Menu.Item>
                            <Menu.Item
                                style={linkStyle}
                                as={Link}
                                active={location.pathname === '/v1/top-competitors'}
                                to='/v1/top-competitors'>
                                Top Competitors
                            </Menu.Item>
                            <Menu.Item
                                style={linkStyle}
                                as={Link}
                                active={location.pathname === '/v1/prospect-profile'}
                                to='/v1/prospect-profile'>
                                Prospect Profile
                            </Menu.Item>
                        </Menu.Menu>
                    </Accordion.Content>
                </Menu.Item>
                <Menu.Item style={menuItemStyle} as={Accordion.Title} onClick={() => this.onHeaderClick('Offerings')}>
                    <Icon name="newspaper" style={iconStyle} />
                    Offerings
                </Menu.Item>
                <Accordion.Content style={menuItemStyle} active={this.offeringsActive()} >
                    <Menu.Menu>
                        {companyStore.company.offerings.map((offering) => <Menu.Item style={linkStyle}
                            key={offering.offering}
                            as={HashLink}
                            active={location.pathname === `/offerings#${offering.offering}`}
                            to={`/v1/offerings#${offering.offering}`}>
                            {offering.offering}
                        </Menu.Item>)}
                    </Menu.Menu>
                </Accordion.Content>
                <Menu.Item style={menuItemStyle} as={Accordion.Title} onClick={() => this.onHeaderClick('General Asks')}>
                    <Icon name="address card outline" style={iconStyle} />
                    General Asks
                </Menu.Item>
                <Menu.Item style={menuItemStyle} as={Accordion.Title} onClick={() => this.onHeaderClick('Question And Answer')}>
                    <Icon name="question" style={iconStyle} />
                    Question & Answer
                </Menu.Item>
                <Divider style={dividerStyle} />
                <Menu.Item style={menuItemStyle}>
                    <Menu.Item as={Accordion.Title} onClick={() => {
                        this.setState({ dashboardActive: !this.state.dashboardActive });
                        this.props.history.push('/v1/dashboard');
                    }}>
                        <Icon name="dashboard" style={iconStyle} />
                        Dashboard
                    </Menu.Item>
                    <Accordion.Content active={this.state.dashboardActive || this.dashboardSectionActive()}>
                        <Menu.Menu>
                            <Menu.Item
                                style={linkStyle}
                                as={Link}
                                active={location.pathname === '/v1/dashboard'}
                                to='/v1/dashboard'>
                                My Dashboard
                            </Menu.Item>
                            {!isSalesMember && (
                                <Menu.Item
                                    style={linkStyle}
                                    as={Link}
                                    active={location.pathname === '/v1/team-dashboard'}
                                    to='/v1/team-dashboard'>
                                    Team Dashboard
                                </Menu.Item>
                            )}
                        </Menu.Menu>
                    </Accordion.Content>
                </Menu.Item>
                {showRecordPresentation && <Menu.Item as={Accordion.Title} onClick={() => this.onHeaderClick('Recording')}>
                    <Icon name="video" style={iconStyle} />
                    Training Hub
                </Menu.Item>}
                {showAssessmentReports &&
                    <Menu.Item
                        as={Link}
                        to='/v1/assessments-report'>
                        <Icon name="chart bar" style={iconStyle} />
                        Performance Reports
                    </Menu.Item>
                }
                <Menu.Item
                    as={Link}
                    to='/v1/my-assessments-report'>
                    <Icon name="certificate" style={iconStyle} />
                    My Performance Reports
                </Menu.Item>
                <div className="ui divider" style={{ borderTop: '1px solid rgba(7, 132, 167, 0.4)', width: '35px', marginLeft: '10px' }}></div>
                <Menu.Item style={menuItemStyle}>
                    <Menu.Item as={Accordion.Title} onClick={() => this.setState({ customPlaybookActive: !this.state.customPlaybookActive })}>
                        <Icon name="book" style={iconStyle} />
                        Playbook
                    </Menu.Item>
                    <Accordion.Content active={this.state.customPlaybookActive}>
                        <Menu.Item style={linkStyle}>
                            <Menu.Item as={Accordion.Title} onClick={() => {
                                const isCurrentlyActive = this.state.buildingMessageActive;
                                this.setState({
                                    buildingMessageActive: !isCurrentlyActive,
                                    onboardingTrainingActive: false,
                                    salesActivityActive: false,
                                    closingActive: false,
                                    skillsLeadershipActive: false
                                });
                                if (!isCurrentlyActive) {
                                    this.props.history.push('/v1/playbook/building-message/sales-deck-explained');
                                }
                            }}>
                                <Icon name="bullhorn" style={iconStyle} />
                                Building the Message
                            </Menu.Item>
                            <Accordion.Content active={this.state.buildingMessageActive}>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/building-message/sales-deck-explained"
                                    active={location.pathname === '/v1/playbook/building-message/sales-deck-explained'}>
                                    Sales Deck - Explained
                                </Menu.Item>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/building-message/example-sales-deck"
                                    active={location.pathname === '/v1/playbook/building-message/example-sales-deck'}>
                                    Example Sales Deck
                                </Menu.Item>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/building-message/messaging-explained"
                                    active={location.pathname === '/v1/playbook/building-message/messaging-explained'}>
                                    Messaging - Explained
                                </Menu.Item>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/building-message/anatomy-sales-cycle"
                                    active={location.pathname === '/v1/playbook/building-message/anatomy-sales-cycle'}>
                                    Anatomy of a Sales Cycle
                                </Menu.Item>
                            </Accordion.Content>
                        </Menu.Item>
                        <Menu.Item style={linkStyle}>
                            <Menu.Item as={Accordion.Title} onClick={() => {
                                const isCurrentlyActive = this.state.onboardingTrainingActive;
                                this.setState({
                                    buildingMessageActive: false,
                                    onboardingTrainingActive: !isCurrentlyActive,
                                    salesActivityActive: false,
                                    closingActive: false,
                                    skillsLeadershipActive: false
                                });
                                if (!isCurrentlyActive) {
                                    this.props.history.push('/v1/playbook/onboarding-training/training-process-explained');
                                }
                            }}>
                                <Icon name="sync alternate" style={iconStyle} />
                                Onboarding/Training
                            </Menu.Item>
                            <Accordion.Content active={this.state.onboardingTrainingActive}>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/onboarding-training/training-process-explained"
                                    active={location.pathname === '/v1/playbook/onboarding-training/training-process-explained'}>
                                    Training Process - Explained
                                </Menu.Item>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/onboarding-training/example-feedback"
                                    active={location.pathname === '/v1/playbook/onboarding-training/example-feedback'}>
                                    Example Feedback
                                </Menu.Item>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/onboarding-training/training-summary"
                                    active={location.pathname === '/v1/playbook/onboarding-training/training-summary'}>
                                    Training - Summary
                                </Menu.Item>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/onboarding-training/example-sales-meetings"
                                    active={location.pathname === '/v1/playbook/onboarding-training/example-sales-meetings'}>
                                    Example Sales Meetings
                                </Menu.Item>
                            </Accordion.Content>
                        </Menu.Item>
                        <Menu.Item style={linkStyle}>
                            <Menu.Item as={Accordion.Title} onClick={() => {
                                const isCurrentlyActive = this.state.salesActivityActive;
                                this.setState({
                                    buildingMessageActive: false,
                                    onboardingTrainingActive: false,
                                    salesActivityActive: !isCurrentlyActive,
                                    closingActive: false,
                                    skillsLeadershipActive: false
                                });
                                if (!isCurrentlyActive) {
                                    this.props.history.push('/v1/playbook/sales-activity/plan-your-interactions');
                                }
                            }}>
                                <Icon name="handshake outline" style={iconStyle} />
                                Sales Activity
                            </Menu.Item>
                            <Accordion.Content active={this.state.salesActivityActive}>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/sales-activity/plan-your-interactions"
                                    active={location.pathname === '/v1/playbook/sales-activity/plan-your-interactions'}>
                                    Plan Your Interactions
                                </Menu.Item>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/sales-activity/sales-activity-explained"
                                    active={location.pathname === '/v1/playbook/sales-activity/sales-activity-explained'}>
                                    Sales Activity - Explained
                                </Menu.Item>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/sales-activity/prospecting"
                                    active={location.pathname === '/v1/playbook/sales-activity/prospecting'}>
                                    Prospecting
                                </Menu.Item>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/sales-activity/intentionality-communication"
                                    active={location.pathname === '/v1/playbook/sales-activity/intentionality-communication'}>
                                    Intentionality of Communication
                                </Menu.Item>
                            </Accordion.Content>
                        </Menu.Item>
                        <Menu.Item style={linkStyle}>
                            <Menu.Item as={Accordion.Title} onClick={() => {
                                const isCurrentlyActive = this.state.closingActive;
                                this.setState({
                                    buildingMessageActive: false,
                                    onboardingTrainingActive: false,
                                    salesActivityActive: false,
                                    closingActive: !isCurrentlyActive,
                                    skillsLeadershipActive: false
                                });
                                if (!isCurrentlyActive) {
                                    this.props.history.push('/v1/playbook/closing/proposal-process-explained');
                                }
                            }}>
                                <Icon name="coffee" style={iconStyle} />
                                Closing
                            </Menu.Item>
                            <Accordion.Content active={this.state.closingActive}>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/closing/proposal-process-explained"
                                    active={location.pathname === '/v1/playbook/closing/proposal-process-explained'}>
                                    Proposal Process Explained
                                </Menu.Item>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/closing/examples-templates"
                                    active={location.pathname === '/v1/playbook/closing/examples-templates'}>
                                    Examples and Templates
                                </Menu.Item>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/closing/abc-corp-sample-proposal"
                                    active={location.pathname === '/v1/playbook/closing/abc-corp-sample-proposal'}>
                                    ABC Corp - Sample Proposal
                                </Menu.Item>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/closing/abc-services-sample-proposal"
                                    active={location.pathname === '/v1/playbook/closing/abc-services-sample-proposal'}>
                                    ABC Services - Sample Proposal
                                </Menu.Item>
                            </Accordion.Content>
                        </Menu.Item>
                        <Menu.Item style={linkStyle}>
                            <Menu.Item as={Accordion.Title} onClick={() => {
                                const isCurrentlyActive = this.state.skillsLeadershipActive;
                                this.setState({
                                    buildingMessageActive: false,
                                    onboardingTrainingActive: false,
                                    salesActivityActive: false,
                                    closingActive: false,
                                    skillsLeadershipActive: !isCurrentlyActive
                                });
                                if (!isCurrentlyActive) {
                                    this.props.history.push('/v1/playbook/skills-leadership/comp-plans');
                                }
                            }}>
                                <Icon name="map outline" style={iconStyle} />
                                Skills, Orgs & Leadership
                            </Menu.Item>
                            <Accordion.Content active={this.state.skillsLeadershipActive}>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/skills-leadership/comp-plans"
                                    active={location.pathname === '/v1/playbook/skills-leadership/comp-plans'}>
                                    Comp Plans
                                </Menu.Item>
                                <Menu.Item
                                    style={{ ...linkStyle, marginLeft: '10px' }}
                                    as={Link}
                                    to="/v1/playbook/skills-leadership/organizational-structures"
                                    active={location.pathname === '/v1/playbook/skills-leadership/organizational-structures'}>
                                    Organizational Structures
                                </Menu.Item>
                            </Accordion.Content>
                        </Menu.Item>
                    </Accordion.Content>
                </Menu.Item>
                <Divider style={dividerStyle} />
                {/* {
                    showModules &&
                    <>
                        <Menu.Item style={menuItemStyle}>
                            <Menu.Item as={Accordion.Title} onClick={() => this.setState({ playbookActive: !this.state.playbookActive })}>
                                <Icon name="book" style={iconStyle} />
                                Playbook
                            </Menu.Item>
                            <Accordion.Content active={this.state.playbookActive}>
                                {
                                    modulesStore.modules.map(module =>
                                        <Menu.Item key={`module_${module.path}`}>
                                            <Menu.Item as={Accordion.Title} onClick={() => this.onModuleHeaderClick(module)}>
                                                <Icon name={module.icon === 'site map' ? 'map' : module.icon} style={iconStyle} />
                                                {module.name}
                                            </Menu.Item>
                                            <Accordion.Content active={this.moduleActive(module)} >
                                                {module.articles.map((article, i) => <Menu.Item
                                                    key={`article_${article.key}`}
                                                    style={linkStyle}
                                                    as={Link}
                                                    active={location.pathname === article.path || (i === 0 && location.pathname === `/${module.path}`)}
                                                    to={article.path}>
                                                    {article.title}
                                                </Menu.Item>)}
                                            </Accordion.Content>
                                        </Menu.Item>
                                    )
                                }
                            </Accordion.Content>
                        </Menu.Item>
                        <Divider style={dividerStyle} />
                    </>
                } */}
                {
                    showUserManagement && (<Menu.Item
                        as={Link}
                        to="/v1/users"
                        active={location.pathname === '/v1/users'}>
                        <Icon name="users" style={iconStyle} />
                        Users
                    </Menu.Item>)
                }

                <Menu.Item
                    as={Link}
                    to="/v1/profile"
                    active={location.pathname === '/v1/profile'}>
                    <Icon name="user" style={iconStyle} />
                    Profile
                </Menu.Item>
                {
                    isAdmin && (<Menu.Item
                        as={Link}
                        to="/v1/admin"
                        active={location.pathname === '/v1/admin'}>
                        <Icon name="cogs" style={iconStyle} />
                        Admin
                    </Menu.Item>)
                }
                {
                    isAdmin && (<Menu.Item
                        as={Link}
                        to="/v1/email-admin"
                        active={location.pathname === '/v1/email-admin'}>
                        <Icon name="mail" style={iconStyle} />
                        Email Management
                    </Menu.Item>)
                }
                <Menu.Item
                    as="a"
                    onClick={this.logout}>
                    <Icon name="sign-out" style={iconStyle} />
                    Sign Out
                </Menu.Item>
                <Divider style={dividerStyle} />
                <Menu.Item
                    as={Link}
                    to="/v1/terms-conditions"
                    active={location.pathname === '/v1/terms-conditions'}>
                    <Icon name="clipboard list" style={iconStyle} />
                    Terms & Conditions
                </Menu.Item>
                <Divider style={dividerStyle} />

            </Accordion >

        );
    }
}

export default withAuth0(withRouter(observer(NavigationMenu)));